import { render, staticRenderFns } from "./buyerRequest.vue?vue&type=template&id=04d39289&scoped=true&"
import script from "./buyerRequest.vue?vue&type=script&lang=js&"
export * from "./buyerRequest.vue?vue&type=script&lang=js&"
import style0 from "./buyerRequest.vue?vue&type=style&index=0&id=04d39289&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d39289",
  null
  
)

export default component.exports